export default __webpack_public_path__ + "static/media/originecode.e641ae4e.jpg";